import styled, { css } from 'styled-components';

export const Table = styled.table`
	width: 100%;
	border: 1px solid #d9d9d9;

	background: #f4f5f6;
`;

export const TableWithScroll = styled.div`
	max-height: 500px;
	overflow: auto;
	border-bottom: 0px 1px solid #d9d9d9;

	${Table} {
		border: 0px 1px solid #d9d9d9;
	}
`;

export const Thead = styled.thead`
	background-color: rgba(9, 21, 38, 0.07);
`;

export const Tr = styled.tr`
	border: 1px solid #d9d9d9;
`;

export const Tbody = styled.tbody``;

export const Th = styled.th`
	font-size: 16px;
	line-height: 22px;
	vertical-align: middle;
	padding: 16px;
	padding-right: 0;
	text-align: left;
`;

export const Td = styled.td<{ Bold?: boolean }>`
	font-size: 16px;
	line-height: 22px;
	padding: 16px;
	vertical-align: middle;
	${(props) =>
		props.Bold &&
		css`
			font-weight: bold;
		`}
`;

export const TdWithNumbers = styled(Td)`
	text-align: center;
`;

export const Complexity = styled(Td)`
	width: 192px;
	max-width: 192px;
`;

export const Name = styled(Td)`
	width: 211px;
	max-width: 211px;
`;

export const Description = styled(Td)`
	width: 311px;
	max-width: 311px;
`;

export const Сorrect = styled(TdWithNumbers)``;

export const СorrectByRF = styled(TdWithNumbers)``;
